// Zapis gotowego editu na dysk — jedna droga dla każdego „Pobierz MP4”.
//
// Link z `/api/render/<id>/download` to podpisany URL R2 BEZ `response-content-disposition`
// (app/render/service.py `read_download_url`), więc R2 oddaje plik jako `video/mp4` inline.
// Otwarty w nowej karcie (albo przez `location.href`) uruchamiał odtwarzacz przeglądarki
// zamiast zapisać plik: człowiek lądował poza aplikacją i zapisywał wideo ręcznie z menu
// odtwarzacza. Bucket ma CORS `GET` dla edimi.ai (deploy/r2_cors.py), więc plik idzie przez
// fetch do bloba i `<a download>` w TEJ karcie. Gdy blob się nie uda (sieć, CORS, wygasły
// podpis), zostaje dawna droga: podpisany link w nowej karcie — plik dalej da się zapisać.

import { fetchDownloadUrl } from './edits'

/** Pobiera edit `id` jako plik `edimi-<8 znaków id>.mp4`. Rzuca tylko, gdy serwer nie wyda linku. */
export async function saveEdit(id: string): Promise<void> {
  const url = await fetchDownloadUrl(id)
  let blob: Blob
  try {
    const r = await fetch(url)
    if (!r.ok) throw new Error(`download ${r.status}`)
    blob = await r.blob()
  } catch {
    click(url, (a) => { a.rel = 'noopener'; a.target = '_blank' })
    return
  }
  const href = URL.createObjectURL(blob)
  click(href, (a) => { a.download = `edimi-${id.slice(0, 8)}.mp4` })
  // Safari zaczyna zapis po kliknięciu, nie w tej samej klatce — URL bloba żyje jeszcze chwilę.
  setTimeout(() => URL.revokeObjectURL(href), 60_000)
}

function click(href: string, set: (a: HTMLAnchorElement) => void) {
  const a = document.createElement('a')
  a.href = href
  set(a)
  document.body.append(a)
  a.click()
  a.remove()
}
